// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"attached-media-display_videoWrapper__ZhX_n"};